import React from 'react';

import { AudioInputFailed } from '@shoflo/polymer/containers/modals/AudioInputFailed/AudioInputFailed';
import CreateMeetingError from '@shoflo/polymer/containers/modals/CreateMeetingError/CreateMeetingError';
import LoadBroadcastError from '@shoflo/polymer/containers/modals/LoadBroadcastError/LoadBroadcastError';
import { MeetingEndedModal } from '@shoflo/polymer/containers/modals/MeetingEnded/MeetingEnded';
import { TokenValidationError } from '@shoflo/polymer/containers/modals/TokenValidationError/TokenValidationError';
import { UnauthorizedError } from '@shoflo/polymer/containers/modals/UnauthorizedError/UnauthorizedError';
import BannerForm from 'containers/modals/BannerForm/BannerForm';
import OverlayForm from 'containers/modals/OverlayForm/OverlayForm';
import SourceFormModal from 'containers/modals/SourceForm/SourceForm';
import ProgramPreview from 'containers/modals/ProgramPreview/ProgramPreview';
import BackgroundForm from 'containers/modals/BackgroundForm/BackgroundForm';
import OverlayTemplates from 'containers/modals/OverlayTemplates/OverlayTemplates';
import MediaTemplates from 'containers/modals/MediaTemplates/MediaTemplates';
import LiveRecordingForm from 'containers/modals/LiveRecordingForm/LiveRecordingForm';
import StreamEndpointForm from 'containers/modals/StreamEndpointForm/StreamEndpointForm';
import BackgroundTemplates from 'containers/modals/BackgroundTemplates/BackgroundTemplates';
import ActiveStreamModal from 'containers/modals/ActiveStream/ActiveStream';
import PresenterBannerForm from 'containers/modals/PresenterBannerForm/PresenterBannerForm';
import DeleteSourceModal from 'containers/modals/DeleteSourceModal/DeleteSourceModal';
import LostRealtimeSocketMessageModal from 'containers/modals/LostRealtimeSocketMessageModal/LostRealtimeSocketMessageModal';
import AssignSpeakers from './containers/modals/AssignSpeakers/AssignSpeakers';
import HostPermissionRemoved from 'containers/modals/HostPermissionRemoved/HostPermissionRemoved';
import { GenericSourceSettings } from './containers/modals/SourceSettings/GenericSourceSettings';
import GenericPresenterSettings from './containers/modals/PresenterSettings/GenericPresenterSettings';
import DeleteRecordingModal from './containers/modals/DeleteRecording/DeleteRecordingModal';

const AppModals = () => {
  return (
    <>
      <SourceFormModal />
      <OverlayForm />
      <BannerForm />
      <BackgroundForm />
      <ProgramPreview />
      <OverlayTemplates />
      <MediaTemplates />
      <GenericPresenterSettings />
      <LiveRecordingForm />
      <StreamEndpointForm />
      <BackgroundTemplates />
      <ActiveStreamModal />
      <PresenterBannerForm />
      <DeleteSourceModal />
      <LoadBroadcastError />
      <CreateMeetingError />
      <LostRealtimeSocketMessageModal />
      <MeetingEndedModal />
      <AudioInputFailed />
      <UnauthorizedError />
      <AssignSpeakers />
      <TokenValidationError />
      <GenericSourceSettings />
      <HostPermissionRemoved />
      <DeleteRecordingModal />
    </>
  );
};

export default AppModals;
